
<template>
  <div class="p-datatable p-component">
    <div class="p-datatable-wrapper">
      <table>
        <thead class="p-datatable-thead">
          <tr>
            <th v-for="(header, j) in headers" :key="j">{{ header }}</th>
          </tr>
        </thead>
        <tbody class="p-datatable-tbody">
          <tr v-for="(row, j) in rows" :key="j">
            <td v-for="(header, i) in headers" :key="i">
              <template v-if="header == 'Value'">
                <template v-if="row.FeatureType == 1">
                  <input
                    type="text"
                    class="form-control"
                    :value="row.Value"
                    @change="updateValue($event, row)"
                  />
                </template>
                <template v-else>
                  <select
                    class="form-control"
                    @change="updateValue($event, row)"
                  >
                    <option
                      v-for="(opt, z) in row.Options.split(',')"
                      :key="z"
                      :value="opt"
                      :data-value="row.Value"
                      :selected="opt == row.Value"
                    >
                      {{ opt }}
                    </option>
                  </select>
                </template>
              </template>
              <template v-else>
                {{ row[header] }}
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { abstractField } from "vue-form-generator";

export default {
  mixins: [abstractField],
  methods: {
    updateValue($event, row) {
      this.value
        .filter((x) => x.Title == row.Title)
        .map((x) => {
          x.Value = $event.target.value;
        });
    },
  },
  computed: {
    headers() {
      return this.value
        ? Object.keys(this.value[0]).filter((x) => x == "Title" || x == "Value")
        : null;
    },
    rows() {
      return this.value ? this.value : null;
    },
  },
};
</script>